import React from 'react';
import getTheme from '../10-parts';
import selectBasedOnThemeID from '../utils/selectBasedOnThemeID';
// ponytail: createContext default is evaluated at import time — before New Arch
// NativeModules may expose ultimate-config. Provider always supplies the real theme.
const FALLBACK_THEME_ID = 'light';
const ThemeContext = React.createContext({
    theme: getTheme(FALLBACK_THEME_ID),
    dimensions: {
        device: {
            height: 0,
            width: 0,
        },
        viewPort: {
            height: 0,
            width: 0,
        },
        safeAreaInsets: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
        breakpoint: {
            width: {
                sm: false,
                md: false,
                lg: false,
            },
            height: {
                sm: false,
                md: false,
                lg: false,
            },
        },
    },
    select: selectBasedOnThemeID(FALLBACK_THEME_ID),
    deviceType: {
        isPhone: false,
        isTablet: false,
        isDesktop: false,
    },
    change(_newTheme) { },
});
export default ThemeContext;
